var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryDocuments = function SvgLibraryDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32.3,
    y1: 178.6,
    x2: 172.1,
    y2: 31.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 20.9,
    y1: 167.8,
    x2: 160.7,
    y2: 20.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 31.3,
    y1: 177.7,
    x2: 171.1,
    y2: 30.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 41.7,
    y1: 187.6,
    x2: 181.5,
    y2: 40.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 52.1,
    y1: 197.4,
    x2: 191.9,
    y2: 50.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 62.5,
    y1: 207.3,
    x2: 202.3,
    y2: 60.5,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.4,25.2c-.1-.1-.3-.2-.4-.4,0,0,0,0,0,0l-22.8-21.8-.3-.3c-.9-.9-1.8-1.8-3.6-1.8h-94.6c-2.8,0-5,2.2-5,5v15.4l-33.3,5.7c-2.7.5-4.5,3-4,5.7l1.7,9.9c-10.8,3.6-21.9,7.4-32.7,11.3-2.5.9-3.9,3.7-3,6.3l21.4,59.4c.4,1.2,1.6,1.9,2.8,1.9s.7,0,1-.2c1.5-.5,2.3-2.2,1.8-3.7L6.1,59.1c10.1-3.6,20.6-7.2,30.8-10.6l10.1,58.7,11.6,67.6c.4,2.4,2.5,4.1,4.9,4.1s.5,0,.8,0l31.4-5.4,24.5-4.2-36.9,13.3-29.1,10.5-22.6-62.8c-.5-1.5-2.2-2.3-3.7-1.8-1.5.5-2.3,2.2-1.8,3.7l22.9,63.7c.4,1.2,1.4,2.2,2.5,2.8.7.3,1.4.5,2.1.5s1.1,0,1.7-.3l29.9-10.8,68-24.4,13-2.2h28.7c2.8,0,5-2.3,5-5V28.5c0-1.8-1-2.6-1.6-3.3ZM190.6,25.9h-15c-.7,0-2.3,0-2.8-.4,0,0-.2-.4-.2-1v-15.8s18,17.2,18,17.2ZM77.5,155.4v-57.1c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9v57.9c0,2.8,2.2,5,5,5h55l-36.9,6.3-30.5,5.2-11.4-66.7-12.6-73.5,31.4-5.4v57.4c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9V6.8h89.2v17.7c0,2.1.7,3.9,2,5.2,2,2,4.8,2.1,6.5,2.1s.3,0,.4,0h18.5s0,123.6,0,123.6h-116.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.3,43.5h-83.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h83.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.3,64.3h-83.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h83.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.3,85.2h-83.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h83.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.3,106h-83.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h83.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.3,126.8h-83.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h83.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })));
};
export default SvgLibraryDocuments;